// @ts-nocheck
import { Fragment } from 'react';
import { CheckCircle } from 'lucide-react';

const WIZARD_STEPS = [
  { id: 'import', label: 'Import Shareholders' },
  { id: 'review', label: 'Review & Exclude DQIs' },
  { id: 'shutdown', label: 'Shutdown Rule' },
  { id: 'precheck', label: 'Pre-Launch Check' },
  { id: 'launch', label: 'Launch Vote Room' },
];

export const VOTE_ROOM_WIZARD_STEPS = WIZARD_STEPS;

/** Five-step pill stepper rendered at the top of the setup wizard. */
export const WizardStepper = ({ step }) => {
  const stepIndex = WIZARD_STEPS.findIndex((s) => s.id === step);
  const activeIndex = stepIndex >= 0 ? stepIndex : 0;
  return (
    <div className="flex items-center" role="list" aria-label="Setup steps">
      {WIZARD_STEPS.map((s, i) => {
        const done = i < activeIndex;
        const active = i === activeIndex;
        return (
          <Fragment key={s.id}>
            {i > 0 && (
              <div
                className={`mx-2 h-px flex-1 ${done ? 'bg-emerald-300' : 'bg-gray-200'} transition-colors`}
                aria-hidden
              />
            )}
            <div className="flex items-center gap-2" role="listitem" aria-current={active ? 'step' : undefined}>
              <span
                className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-all ${
                  active
                    ? 'bg-emerald-600 text-white ring-4 ring-emerald-100'
                    : done
                      ? 'bg-emerald-500 text-white'
                      : 'bg-gray-100 text-gray-400'
                }`}
                aria-hidden
              >
                {done ? <CheckCircle size={12} strokeWidth={2.5} /> : i + 1}
              </span>
              <span
                className={`text-xs font-semibold ${active ? 'text-gray-900' : done ? 'text-emerald-700' : 'text-gray-400'}`}
              >
                {s.label}
              </span>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
